export const TILE_HEIGHT = 52;
export const TILE_WIDTH = 82;
export const COLUMNS = 7;
